import { Json } from "../../integrations/supabase/types";
import { Meeting, MeetingNotes } from "../../types/meetings";
import { ActionItem } from "../../types/actionItems";

export function convertToMeeting(data: any): Meeting {
  return {
    ...data,
    tags: data.tags ? (typeof data.tags === 'string' ? data.tags.split(',').filter(Boolean) : data.tags) : [],
    action_items: (data.action_items || []).map(convertToActionItem),
    meeting_notes: (data.meeting_notes || []).map(convertToMeetingNotes)
  };
}

export function convertToActionItem(data: any): ActionItem {
  return {
    id: data.id,
    user_id: data.user_id,
    title: data.title,
    description: data.description || null,
    status: data.status,
    due_date: data.due_date || null,
    is_completed: data.is_completed || false,
    created_at: data.created_at || null,
    updated_at: data.updated_at || null,
    assignee: data.assignee || null,
    priority: data.priority || null,
    reference: data.reference || null,
    instructions: data.instructions || null,
    context: data.context || null,
    additional_notes: data.additional_notes || null,
    meeting_id: data.meeting_id || null
  };
}

export function convertToMeetingNotes(data: any): MeetingNotes {
  return {
    meeting_id: data.meeting_id,
    user_id: data.user_id,
    summary: data.summary || null,
    notes: data.notes || null,
    key_points: data.key_points || null,
    sentiment: data.sentiment || null,
    metadata: data.metadata || null,
    action_items: Array.isArray(data.action_items) ? data.action_items.map(convertToActionItem) : [],
    participants: Array.isArray(data.participants) ? data.participants : [],
    quick_summary: data.quick_summary || null,
    detailed_notes: data.detailed_notes || null,
    decisions: Array.isArray(data.decisions) ? data.decisions : [],
    follow_ups: Array.isArray(data.follow_ups) ? data.follow_ups : [],
    engagement_metrics: data.engagement_metrics || null
  };
}